<template>
  <v-snackbar
    v-model="model"
    :color="snackbar.type"
    :timeout="snackbar.timeout"
    right
  >
    <v-row>
      <v-col
        :class="snackbar.type === 'warning' ? 'black--text' : 'white--text'"
        :alvqa="alvqa + '-text'"
        v-html="snackbar.msg"
      >
      </v-col>
        <v-btn
          v-if="snackbar.type === 'success' && snackbar.timeout === -1"
          dark
          text
          class="text-right" 
          @click="model = false"
        >
          <v-icon :alvqa="alvqa + '-icon'">
            close
          </v-icon>
        </v-btn>
    </v-row>
  </v-snackbar>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Snackbar',    
    data() {
      return {
        model: false,
        alvqa: "snackbar"
      }
    },

    computed: {
      ...mapState(['snackbar']),
    },

    watch: {
      snackbar () { this.model = true }
    }
  }
</script>